module.exports = __webpack_public_path__ + "img/Rlogo.41b1857d.svg";